export class UnifiedRestoreEntity {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "UnifiedRestoreEntityType",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "userPrincipalName",
            "baseName": "userPrincipalName",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "directoryPresence",
            "baseName": "directoryPresence",
            "type": "UnifiedRestoreDirectoryPresence",
            "format": ""
        },
        {
            "name": "relationships",
            "baseName": "relationships",
            "type": "UnifiedRestoreEntityRelationships",
            "format": ""
        },
        {
            "name": "microsoft365",
            "baseName": "microsoft365",
            "type": "UnifiedRestoreEntityMicrosoft365",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedRestoreEntity.attributeTypeMap;
    }
    constructor() {
    }
}
